module.exports = __webpack_public_path__ + "img/img-4.ae0905d7.webp";